import { render, staticRenderFns } from "./DeleteOverrideButton.vue?vue&type=template&id=4e9b6624&scoped=true"
import script from "./DeleteOverrideButton.vue?vue&type=script&lang=js"
export * from "./DeleteOverrideButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteOverrideButton.vue?vue&type=style&index=0&id=4e9b6624&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b6624",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9b6624')) {
      api.createRecord('4e9b6624', component.options)
    } else {
      api.reload('4e9b6624', component.options)
    }
    module.hot.accept("./DeleteOverrideButton.vue?vue&type=template&id=4e9b6624&scoped=true", function () {
      api.rerender('4e9b6624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/DeleteOverrideButton.vue"
export default component.exports